import formInputsTypes from '../simulatorConstant';
import StoreBanne from 'assets/img/store-banne.png';
import StoreEnrouleur from 'assets/img/enrouleur.png';
import StoreProjection from 'assets/img/projection.png';

import StoreBanneToile from 'assets/img/store-banne-toile.png';
import StoreBrasDroits from 'assets/img/store-bras-droite.png';
import StoreDecenteVertical from 'assets/img/store-descente-verticale.png';
import StoreDoublePente from 'assets/img/store-double-pente.png';

import StoreDemiCoffre from 'assets/img/store-demi-coffre.png';

import StoreCoffre from 'assets/img/store-demi-coffre.png';
import StoreMonobloc from 'assets/img/store-monobloc.png';
import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import ManoeuvreChainette from 'assets/img/chainette.png';
import Filaire from 'assets/img/stock/Filaire.png';
import Radio from 'assets/img/stock/Radio.png';
import Solaire from 'assets/img/stock/Solaire.png';

import StoreCapteurVent from 'assets/img/store-capteur-vent.png';
import StoreSansCapteurVent from 'assets/img/store-sans-capteur-vent.png';
import DicksonToile from 'assets/img/dickson-toile.png';
import LamrequinDroite from 'assets/img/lambrequin-droite.png';
import LambrequinEnroulable from 'assets/img/lambrequin-enroulable.png';
import LambrequinOndulee from 'assets/img/lambrequin-ondulee.png';
import LambrequinVagues from 'assets/img/lambrequin-vagues.png';
import LatimToile from 'assets/img/latim-toile.png';
import SansLambrequin from 'assets/img/sans-lambrequin.png';
import SauledaToile from 'assets/img/sauleda-toile.png';
import manivelles from 'assets/img/stock/store/manivelle.jpg';
import generateData from 'common/function/generateData';
import droite from 'assets/img/stock/store/Droite.jpg';

import gauche from 'assets/img/stock/store/Gauche.jpg';
import ScreenToile from 'assets/img/screen.png';
import JourNuitToile from 'assets/img/journuit.png';
import OccultantToile from 'assets/img/occultant.png';
import SoltisToile from 'assets/img/soltis.png';

import Tableau from 'assets/img/tableau.png';
import Mural from 'assets/img/mural.png';
import Plafond from 'assets/img/plafond.png';

import Raye from 'assets/img/raye.png';
import Fantaisie from 'assets/img/fantaisie.png';
import Uni from 'assets/img/uni.png';
import Technique from 'assets/img/technique.png';

import Inox from 'assets/img/Inox.png';
import Coulisses from 'assets/img/coulisses.png';

import ToileStoreBanne from 'assets/img/toile-store-banne.png';
import MoteurStoreBanne from 'assets/img/moteur-store-banne.png';

import DicksonStaticProductsData from './DicksonStaticProductsData.json'
import SauledaStaticProductsData from './SauledaStaticProductsData.json'

const capteur = {
	id: 'capteur_vent',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Capteur de vent',
	name: 'capteur_vent',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 'avec',
			label: 'Avec capteur de vent',
			value: 'Avec capteur de vent',
			imageUrl: StoreCapteurVent,
			description: '- Avec capteur de vent',
			nextStep: false,
		},
		{
			id: 'sans',
			label: 'Sans capteur de vent',
			value: 'Sans capteur de vent',
			imageUrl: StoreSansCapteurVent,
			nextStep: false,
			description: '- Sans capteur de vent',

		},
	],
};

const sortie = {
	id: 'sortie',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie électrique (vue en face)',
	name: 'sortie',
	nextStepData: false,
	classGroup: 'SProduit',
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const moteurValue = currentFormValue?.values?.moteur?.value;
		const typeStore = currentFormValue?.values?.typeStore?.value;
		const nextStep = () => {
			if (typeStore == "Store Banne") return capteur
			return false

		}
		// Normalize moteur text (avoid undefined)
		const moteurText = moteurValue ? moteurValue : 'Motorisation';

		const generateDescription = (position) => {
			// "vue en face" => "vue de face" (better French)
			return `- ${moteurText} : sortie à ${position} (vue de face)`;
		};

		const options = [
			{
				id: 'gauche',
				label: 'Gauche',
				value: 'gauche',
				imageUrl: gauche,
				nextStep: nextStep(),
				description: generateDescription('gauche'),
			},
			{
				id: 'droite',
				label: 'Droite',
				value: 'droite',
				imageUrl: droite,
				nextStep: nextStep(),
				description: generateDescription('droite'),
			},
		];

		fnSuccess(options);
	},
};

const moteur = {
	id: 'moteur',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de motorisation',
	name: 'moteur',
	nextStepData: sortie,
	nextStep: false,
	options: [
		{
			id: 'motorisation_radio',
			label: 'Radio',
			value: 'Motorisation radio',
			imageUrl: Radio,
			nextStep: false,
			description: '- Manœuvre motorisée radio avec commande à distance, assurant un confort d’utilisation optimal..',
		},
		{
			id: 'motorisation_filaire',
			label: 'Filaire',
			value: 'Motorisation filaire',
			imageUrl: Filaire,
			nextStep: false,
			description: '- Manœuvre motorisée filaire avec commande murale, assurant un confort d’utilisation optimal..',
		},
	],
};

const sortieManivelle = {
	id: 'sortie',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie manivelle (vue en face)',
	name: 'sortie',
	nextStepData: false,
	classGroup: 'SProduit',
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		// Normalize moteur text (avoid undefined)
		const hauteur = currentFormValue?.values?.hauteur_manivelle_store?.value

		const generateDescription = (position) => {
			// "vue en face" => "vue de face" (better French)
			return `- Manoeuvre manuelle par manivelle ${hauteur} à ${position} (vue de face)`;
		};

		const options = [
			{
				id: 'gauche',
				label: 'Gauche',
				value: 'gauche',
				imageUrl: gauche,
				description: generateDescription('gauche'),
			},
			{
				id: 'droite',
				label: 'Droite',
				value: 'droite',
				imageUrl: droite,
				description: generateDescription('droite'),
			},
		];

		fnSuccess(options);
	},
};

const hauteur_manivelle = {
	id: 'hauteur_manivelle_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Hauteur de votre manivelle',
	name: 'hauteur_manivelle_store',
	classGroup: 'SProduit',
	nextStepData: sortieManivelle,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		let data = '';
		const generateDescription = (hauteur) => {
			return `Manoeuvre manuelle par manivelle ${hauteur}`;
		};
		const options = [
			{
				id: '50',
				label: '500 mm',
				value: '500 mm',
				// description: generateDescription('500 mm'),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '80',
				label: '800 mm',
				value: '800 mm',
				// description: generateDescription('800 mm'),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '100',
				label: '1000 mm',
				value: '1000 mm',
				// description: generateDescription('1000 mm'),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '120',
				label: '1200 mm',
				value: '1200 mm',
				// description: generateDescription('1200 mm'),
				imageUrl: manivelles,
				nextStep: false,
			},
			{
				id: '180',
				label: '1800 mm',
				value: '1800 mm',
				// description: generateDescription('1800 mm'),
				imageUrl: manivelles,
				nextStep: false,
			},
		];

		fnSuccess(options);
	},
};

export const manoeuvre = {
	id: 'manoeuvre_store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Manœuvre',
	name: 'manoeuvre_store',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeStore =
			currentFormValue?.values?.typeStore?.value == 'Store enrouleur'


		// const isEnrouleurInterieur =
		// 	typeStore === 'Store enrouleur' intérieur' ||
		// 	typeStore === 'Enrouleur intérieur';

		const options = [
			{
				id: 'manuel',
				label: 'Manuel',
				value: 'Manuel',
				imageUrl: typeStore ? ManoeuvreChainette : ManoeuvreManuel,
				nextStep: typeStore ? false : hauteur_manivelle,
				description: typeStore
					? '- Manœuvre manuelle par chaînette.'
					: '',
			},
			{
				id: 'electrique',
				label: 'Électrique',
				value: 'Électrique',
				imageUrl: ManoeuvreElectrique,
				nextStep: moteur,
			},
		];

		fnSuccess(options);
	},
};


const couleurInput = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_TEXT,
	name: 'couleur',
	className: 'col-6',
	label: 'Réf couleur toile',
	placeholder: 'Gris',
	nextStep: false,
	nextStepData: manoeuvre,
};

const couleurDisckson = {
	id: 'STORE-TOILE-REF',
	type: formInputsTypes?.SELECT_INPUT,
	name: 'couleur',
	className: 'col-6',
	label: 'Réf couleur toile',
	placeholder: 'Sélectionner une référence',
	nextStep: false,
	nextStepData: false,
	options: null,

	fetchData: async (currentFormValue, fnSuccess) => {
		try {
			const isDickson = currentFormValue?.values?.typeToile?.value == "Dickson/Orchestra"
			const isFinal = currentFormValue?.values?.fabrication?.value == "Toile";
			const p = currentFormValue?.values?.motif?.value
			const makeDesc = () => {
				if (p === 'Uni') {
					return ' Couleur de la Toile unie,';
				}
				if (p === 'Rayure classique') {
					return ' Couleur de la Toile rayée,';
				}
				if (p === 'Rayure Fantaisie') {
					return ' Couleur de la Toile à motifs fantaisie,';
				}

				return '';
			};
			// ✅ Ton endpoint (tel quel)
			const motifMap = {
				Uni: 518,
				'Rayure classique': 519,
				'Rayure Fantaisie': 521,
			};

			const nextStep = () => {
				if (!!isFinal) return false
				return manoeuvre
			}
			const couleurId =
				currentFormValue?.values?.couleurCategorie?.value
			const motif = currentFormValue?.values?.motif?.value
			const motifId = motifMap[motif] || '518';
			const opacite = currentFormValue?.values?.opacite?.value == "Tamisant" ? 514 : 506;
			const opaciteId = !!isDickson ? opacite : '';
			const key = `${motifId}-${couleurId}`;
			const products = !!isDickson ? DicksonStaticProductsData[key] || [] : SauledaStaticProductsData[key] || [];


			const options = products.map((it) => ({
				id: it.ref,
				label: `${it.ref}`,
				value: it.ref,
				imageUrl: it.photo,
				description: `-${makeDesc()} ${it.name || it.ref}`,
				nextStep: nextStep(),
			}));


			// Transform to options


			fnSuccess(options);
		} catch (e) {
			// Fallback safe
			fnSuccess([]);
		}
	},
};



const couleurCategorie = {
	id: 'STORE-COULEUR-CAT',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'couleurCategorie',
	className: 'col-12',
	label: 'Couleur (famille)',
	nextStepData: couleurDisckson,
	nextStep: false,

	// Full list (base)


	// ✅ Add fetchData to filter colors by motif
	fetchData: (currentFormValue, fnSuccess) => {
		const motif = currentFormValue?.values?.motif?.value; // 'Uni' | 'Rayé' | 'Fantaisie'
		const marque = currentFormValue?.values?.typeToile?.value

		let allowedByMotif = []
		if (marque == "Dickson/Orchestra") {
			allowedByMotif = {
				'Rayure classique': new Set(['487', '492', '493', '494', '495', '496', '497']), // noir marron gris vert jaune rouge bleu
				'Rayure Fantaisie': new Set(['487', '492', '490', '491', '493', '488', '494', '495', '497', '496']), // noir marron violet beige gris orange vert jaune bleu rouge
				// 'Uni' => all (no filter)
			};
		}
		if (marque == "Sauleda") {
			allowedByMotif = {
				'Rayure classique': new Set(['488', '492', '493', '494', '495', '496', '497']), // noir marron gris vert jaune rouge bleu
				'Rayure Fantaisie': new Set(['488', '492', '491', '489', '493', '494', '495', '497', '496']), // noir marron violet beige gris orange vert jaune bleu rouge
				// 'Uni' => all (no filter)
			};
		}
		// Use IDs (string) to match your options ids reliably


		const baseOptions = [
			{ id: '485', label: 'Blanc', value: 485, color: '#ffffff', icon: 'CustomCircle', },
			{ id: '487', label: 'Noir', value: 487, color: '#1f1c1d', icon: 'CustomCircle', },
			{ id: '488', label: 'Orange', value: 488, color: '#e66f33', icon: 'CustomCircle', },
			{ id: '489', label: 'Rose', value: 489, color: '#d64896', icon: 'CustomCircle', },
			{ id: '490', label: 'Violet', value: 490, color: '#4a288e', icon: 'CustomCircle', },
			{ id: '491', label: 'Beige', value: 491, color: '#fdbe7f', icon: 'CustomCircle', },
			{ id: '492', label: 'Marron', value: 492, color: '#ac5f1d', icon: 'CustomCircle', },
			{ id: '493', label: 'Gris', value: 493, color: '#9c9c9c', icon: 'CustomCircle', },
			{ id: '494', label: 'Vert', value: 494, color: '#95c045', icon: 'CustomCircle', },
			{ id: '495', label: 'Jaune', value: 495, color: '#fdf051', icon: 'CustomCircle', },
			{ id: '496', label: 'Rouge', value: 496, color: '#d0373b', icon: 'CustomCircle', },
			{ id: '497', label: 'Bleu', value: 497, color: '#49add6', icon: 'CustomCircle', },
		]

		const filtered =
			motif === 'Uni' || !allowedByMotif[motif]
				? baseOptions
				: baseOptions.filter((opt) => allowedByMotif[motif].has(String(opt.id)));

		fnSuccess(filtered);
	},
};





const Typetoile = {
	id: 'T_Store_TOILE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Opacité de toile',
	name: 'opacite',
	nextStepData: couleurCategorie,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {

		// Next step depends on store type

		const toileTech = (id, label, value, imageUrl, descLines) => ({
			id,
			label,
			value,
			imageUrl,
			description: descLines.map((l) => `- ${l}`).join('\n'),
		});

		// Options by store type (incl. enrouleur intérieur/extérieur)

		const options = [
			toileTech('TOILE_TAMISANT', 'Tamisant (semi-transparent)', 'Tamisant', ScreenToile, [
				'Toile Tamisant, conçue pour filtrer la lumière tout en préservant le confort visuel. Permet de conserver une visibilité vers l’extérieur selon le taux d’ouverture.',

			]),
			toileTech('TOILE_OCC', 'Occultante (obscurité totale)', 'Occultante', OccultantToile, [
				'Toile occultante offrant une protection maximale contre la lumière.',
			]),
			toileTech('TOILE_JN', 'Jour / Nuit (réglage lumière)', 'Jour / Nuit', JourNuitToile, [
				'Toile Jour/Nuit alternant bandes tamisantes et occultantes pour régler la luminosité. Permet un ajustement précis entre intimité et entrée de lumière.',

			]),
		]

		fnSuccess(options);
	},

};
const Gammetoile = {
	id: 'PG-PREST',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'motif',
	className: 'col-6',
	label: 'Motif de toile',

	fetchData: (currentFormValue, fnSuccess) => {
		const isEnrouleur = currentFormValue?.values?.typeStore?.value == "Store enrouleur"

		const allowed = ['Uni', 'Rayure classique', 'Rayure Fantaisie']


		const makeImg = (p) => {
			if (p === 'Uni') {
				return Uni
			}
			if (p === 'Rayure classique') {
				return Raye
			}
			if (p === 'Rayure Fantaisie') {
				return Fantaisie
			}

			return '';
		};


		const options = allowed.map((p) => ({
			id: p,
			label: p,
			value: p,
			// description: makeDesc(p),
			imageUrl: makeImg(p),
			nextStep: (p === 'Uni' && isEnrouleur) ? Typetoile : couleurCategorie
		}));

		fnSuccess(options);
	},
};

const MarqueTypetoile = {
	id: 'T_Store_TOILE',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Marque de la toile',
	name: 'typeToile',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeStore =
			currentFormValue?.values?.typeStore?.value ||
			currentFormValue?.typeStore?.value ||
			currentFormValue?.typeStore;



		// Helper builders
		const toileAcrylique = (id, label, value, imageUrl, marque) => ({
			id,
			label,
			value,
			imageUrl,
			nextStep: Gammetoile,
			description:
				`- Toile acrylique ${marque}, grammage 300 g/m².\n` +
				`(Protection efficace contre les rayons ultraviolets)`,
		});




		const options = [
			toileAcrylique(
				'TOILE_DICKSON',
				'Dickson / Orchestra',
				'Dickson/Orchestra',
				DicksonToile,
				'Dickson Orchestra',
			),
			toileAcrylique('TOILE_SAULEDA', 'Sauleda', 'Sauleda', SauledaToile, 'Sauleda'),
		]

		fnSuccess(options);
	},

};

const hauteurLambrequin = {
	id: 'hauteurLambrequin',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteurLambrequin',
	className: 'col-6',
	label: "Hauteur du Lambrequin (mm)",
	nextStepData: MarqueTypetoile,
	nextStep: false,
	placeholder: '200',
	validation: (value) => {
		return value >= 0;
	},
};

const lambrequin = {
	id: 'lambrequin',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Lambrequin',
	name: 'lambrequin',
	nextStepData: false,
	nextStep: false,
	fetchData: (currentFormValue, fnSuccess) => {
		const typeStore = currentFormValue?.values?.typeStore?.value;

		if (typeStore == "Store à projection") {
			fnSuccess([
				{
					id: 'sans_lambrequin',
					label: 'Sans lambrequin',
					value: 'Sans lambrequin',
					imageUrl: SansLambrequin,
					nextStep: MarqueTypetoile,
					description: '- Sans lambrequin, finition standard sans protection frontale.',
				},
				{
					id: 'coupe_droite',
					label: 'Coupe droite',
					value: 'Lambrequin coupe droite',
					imageUrl: LamrequinDroite,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe droite, apportant une finition sobre et une protection visuelle frontale.',
				},
				{
					id: 'coupe_ondulee',
					label: 'Coupe ondulée',
					value: 'Lambrequin coupe ondulée',
					imageUrl: LambrequinOndulee,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe ondulée, offrant un aspect décoratif et une protection solaire frontale.',
				},
				{
					id: 'coupe_vagues',
					label: 'Coupe à vagues',
					value: 'Lambrequin coupe à vagues',
					imageUrl: LambrequinVagues,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe en vagues, pour une finition esthétique marquée et une protection frontale renforcée.',
				},

			])
		}
		if (typeStore == "Store Banne") {
			fnSuccess([
				{
					id: 'sans_lambrequin',
					label: 'Sans lambrequin',
					value: 'Sans lambrequin',
					imageUrl: SansLambrequin,
					nextStep: MarqueTypetoile,
					description: '- Sans lambrequin, finition standard sans protection frontale.',
				},
				{
					id: 'coupe_droite',
					label: 'Coupe droite',
					value: 'Lambrequin coupe droite',
					imageUrl: LamrequinDroite,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe droite, apportant une finition sobre et une protection visuelle frontale.',
				},
				{
					id: 'coupe_ondulee',
					label: 'Coupe ondulée',
					value: 'Lambrequin coupe ondulée',
					imageUrl: LambrequinOndulee,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe ondulée, offrant un aspect décoratif et une protection solaire frontale.',
				},
				{
					id: 'coupe_vagues',
					label: 'Coupe à vagues',
					value: 'Lambrequin coupe à vagues',
					imageUrl: LambrequinVagues,
					nextStep: hauteurLambrequin,
					description:
						'- Lambrequin fixe à coupe en vagues, pour une finition esthétique marquée et une protection frontale renforcée.',
				},
				{
					id: 'lambrequin_enroulable',
					label: 'Lambrequin enroulable 150 mm',
					value: 'Lambrequin enroulable 150 mm',
					imageUrl: LambrequinEnroulable,
					nextStep: MarqueTypetoile,
					description:
						'- Lambrequin enroulable de 150 mm, permettant un réglage de la protection solaire frontale selon l’ensoleillement.',
				},
			])
		}



	},
};

const fixation_basse = {
	id: 'fixation_basse',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation basse',
	name: 'fixation_basse',
	nextStepData: lambrequin,
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const value_ids = [
			{ v: 'Couture simple', d: '- Finition Basse de la toile : Couture simple' },
			{ v: 'Jonc 3mm inclus', d: '- Finition Basse de la toile : Jonc de 3 mm' },
			{ v: 'Jonc 4mm inclus', d: '- Finition Basse de la toile : Jonc de 4 mm' },
			{ v: 'Jonc 5mm inclus', d: '- Finition Basse de la toile : Jonc de 5 mm' },
			{ v: 'Jonc 5.5mm inclus', d: '- Finition Basse de la toile : Jonc de 5,5 mm' },
			{ v: 'Jonc 6mm inclus', d: '- Finition Basse de la toile : Jonc de 6 mm' },
			{ v: 'Jonc 7mm inclus', d: '- Finition Basse de la toile : Jonc de 7 mm' },
			{ v: 'Jonc 8mm inclus', d: '- Finition Basse de la toile : Jonc de 8 mm' },
			{ v: 'Fourreau pour tube 20mm', d: '- Finition Basse de la toile : Fourreau pour tube 20 mm' },
			{ v: 'Fourreau pour tube 30mm', d: '- Finition Basse de la toile : Fourreau pour tube 30 mm' },
			{ v: 'Fourreau pour tube 40mm', d: '- Finition Basse de la toile : Fourreau pour tube 40 mm' },
			{ v: 'Fourreau pour tube 50mm', d: '- Finition Basse de la toile : Fourreau pour tube 50 mm' },
			{ v: 'Fourreau pour tube 70mm', d: '- Finition Basse de la toile : Fourreau pour tube 70 mm' },
			{ v: 'Fourreau pour tube 80mm', d: '- Finition Basse de la toile : Fourreau pour tube 80 mm' },
			{ v: 'Fourreau pour tube 90mm', d: '- Finition Basse de la toile : Fourreau pour tube 90 mm' }
		];
		const options = value_ids?.length
			? value_ids?.map((item) => ({
				id: item.v,
				label: item.v,
				value: item.v,
				description: item.d,

			}))
			: [];
		fnSuccess(options);
	},
};

const fixation_haute = {
	id: 'fixation_haute',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Fixation haute',
	name: 'fixation_haute',
	nextStep: false,
	options: null,
	fetchData: (currentFormValue, fnSuccess) => {
		const typeStore = currentFormValue?.values?.typeStore?.value;
		const nextStep = () => {
			if (typeStore == "Store Banne") {
				return fixation_basse
			}
			if (typeStore == "Store à projection") {
				return lambrequin
			}
		}
		let value_ids = []
		if (typeStore == "Store à projection") {
			value_ids = [
				{ v: 'Murale (façade)', d: '- Fixation murale en façade, pose directe sur le mur extérieur.', img: Mural },
				{ v: 'En tableau (Entre murs)', d: '- Fixation en tableau, pose à l’intérieur de l’embrasure de la fenêtre.', img: Tableau },

			];
		}
		if (typeStore == "Store Banne") {
			value_ids = [
				{ v: 'Couture simple', d: '- Finition Haute de la toile : Couture simple' },
				{ v: 'Jonc 3mm inclus', d: '- Finition Haute de la toile : Jonc de 3 mm' },
				{ v: 'Jonc 4mm inclus', d: '- Finition Haute de la toile : Jonc de 4 mm' },
				{ v: 'Jonc 5mm inclus', d: '- Finition Haute de la toile : Jonc de 5 mm' },
				{ v: 'Jonc 5.5mm inclus', d: '- Finition Haute de la toile : Jonc de 5,5 mm' },
				{ v: 'Jonc 6mm inclus', d: '- Finition Haute de la toile : Jonc de 6 mm' },
				{ v: 'Jonc 7mm inclus', d: '- Finition Haute de la toile : Jonc de 7 mm' },
				{ v: 'Jonc 8mm inclus', d: '- Finition Haute de la toile : Jonc de 8 mm' },
				{ v: 'Fourreau pour tube 20mm', d: '- Finition Haute de la toile : Fourreau pour tube 20 mm' },
				{ v: 'Fourreau pour tube 30mm', d: '- Finition Haute de la toile : Fourreau pour tube 30 mm' },
				{ v: 'Fourreau pour tube 40mm', d: '- Finition Haute de la toile : Fourreau pour tube 40 mm' },
				{ v: 'Fourreau pour tube 50mm', d: '- Finition Haute de la toile : Fourreau pour tube 50 mm' },
				{ v: 'Fourreau pour tube 70mm', d: '- Finition Haute de la toile : Fourreau pour tube 70 mm' },
				{ v: 'Fourreau pour tube 80mm', d: '- Finition Haute de la toile : Fourreau pour tube 80 mm' },
				{ v: 'Fourreau pour tube 90mm', d: '- Finition Haute de la toile : Fourreau pour tube 90 mm' }
			];
		}


		const options = value_ids.map((item) => ({
			id: item.v,
			label: item.v,
			value: item.v,
			description: item.d,
			nextStep: nextStep(),
			imageUrl: item?.img || false
		}));
		fnSuccess(options);
	},
};


const avancee = {
	id: 'Avance',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'avancee',
	className: 'col-6',
	label: "Avancee du store (mm)",
	nextStepData: fixation_haute,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const hauteurStoreEnrouleur = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Hauteur du store (mm)',
	nextStepData: MarqueTypetoile,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const largeurStoreEnrouleur = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Largeur du store (mm)',
	nextStepData: hauteurStoreEnrouleur,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const largeurStorebanne = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Largeur du store (mm)',
	nextStepData: avancee,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const typePoseEnrouleur = {
	id: 'TYPE_POSE_ENROULEUR',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de fixation',
	name: 'typePoseEnrouleur',
	className: 'col-12',
	nextStepData: largeurStoreEnrouleur, // mets ici ton next step (ex: largeurEnrouleur)
	nextStep: false,
	options: [
		{
			id: 'POSE_MURALE',
			label: 'Murale (façade)',
			value: 'Murale',
			imageUrl: Mural,
			nextStep: false,
			description: '- Pose murale : fixation directe sur le mur, au-dessus ou autour de la fenêtre.',
		},
		{
			id: 'POSE_PLAFOND',
			label: 'Plafond',
			value: 'Plafond',
			imageUrl: Plafond,
			nextStep: false,
			description: '- Pose plafond : fixation sous plafond ou sous linteau, idéale pour les baies vitrées.',
		},
		{
			id: 'POSE_TABLEAU',
			label: 'En tableau (Entre murs)',
			value: 'Tableau',
			imageUrl: Tableau,
			nextStep: false,
			description: '- Pose en tableau : fixation à l’intérieur de l’embrasure de la fenêtre, solution discrète.',
		},

		// {
		// 	id: 'Autre',
		// 	label: 'Autre',
		// 	value: 'Autre',
		// 	// imageUrl: PoseTableauImg,
		// 	nextStep: false,
		// },
	],
};

const guidage = {
	id: 'Type de guidage',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de guidage',
	name: 'Type de guidage',
	className: 'col-12',
	nextStepData: typePoseEnrouleur,
	nextStep: false,
	options: [
		{
			id: 'TSBD1',
			label: 'Câbles inox',
			value: 'Guidage par câbles inox',
			imageUrl: Inox,
			nextStep: false,
			description: "- Guidage par câbles inox"

		},
		{
			id: 'TSBD2',
			label: 'Coulisses aluminium',
			value: 'Guidage par coulisses aluminium',
			imageUrl: Coulisses,
			nextStep: false,
			description: "- Guidage par coulisses aluminium."

		},
	],
}
const avanceeComplet = {
	id: 'Avance',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'avancee',
	className: 'col-6',
	label: "Avancée de store (mm)",
	nextStepData: lambrequin,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const largeurStorebanneComplet = {
	id: 'L-TOILE',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurToile',
	className: 'col-6',
	label: 'Largeur du store (mm)',
	nextStepData: avanceeComplet,
	nextStep: false,
	validation: (value) => {
		return value >= 0;
	},
};

const TypeStorebanne = {
	id: 'T_Store',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de coffre',
	name: 'TypeStorebanne',
	nextStepData: false,
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const typeStore = currentFormValue?.values?.typeStore?.value;
		const isEx = currentFormValue?.values?.typeEnrouleur?.value == "Extérieur";
		const nextStep = () => {
			if (typeStore == "Store Banne") {
				const fabrication = currentFormValue?.values?.fabrication?.value;
				if (fabrication == "Store banne") return largeurStorebanneComplet

				return largeurStorebanne
			}
			if (typeStore == "Store à projection") {
				return largeurStorebanne
			}
			if (typeStore == "Store enrouleur") {
				if (!!isEx) {
					return guidage
				}
				return typePoseEnrouleur
			}
		}


		const options = [
			{
				id: 'TSB3',
				label: 'Monobloc (sans coffre)',
				value: 'Monobloc',
				imageUrl: StoreMonobloc,
				nextStep: nextStep(),
				description: "- Monobloc (sans coffre)"

			},
			{
				id: 'TSB2',
				label: 'Coffre',
				value: 'Coffre',
				imageUrl: StoreCoffre,
				nextStep: nextStep(),
				description: "- Avec Coffre"

			},
			{
				id: 'TSB1',
				label: 'Semi coffre',
				value: 'Semi coffre',
				imageUrl: StoreDemiCoffre,
				nextStep: nextStep(),
				description: "- Semi Coffre"

			},
		]
		fnSuccess(options);
	},
};
// const typeProjection = {
// 	id: 'typeProjection',
// 	type: formInputsTypes?.RADIO_INPUT,
// 	label: 'Type de Projection',
// 	name: 'typeProjection',
// 	className: 'col-12',
// 	nextStepData: TypeStorebanne,
// 	nextStep: false,
// 	options: [
// 		{
// 			id: 'TSBD1',
// 			label: 'Bras Droite',
// 			value: 'Projection droite',
// 			imageUrl: BrasDroite,
// 			nextStep: false,
// 			description: "Store à projection (bras droite)."

// 		},
// 		{
// 			id: 'TSBD2',
// 			label: 'Italienne',
// 			value: 'Projection italienne',
// 			imageUrl: StoreProjection,
// 			nextStep: false,
// 			description: "Store à projection (italienne)."

// 		},
// 	],
// }





const typeEnrouleur = {
	id: 'typeEnrouleur',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de store enrouleur',
	name: 'typeEnrouleur',
	className: 'col-12',
	nextStepData: false, // ou le prochain step logique
	nextStep: false,
	options: [
		{
			id: 'TSEN_INT',
			label: 'Intérieur',
			value: 'Intérieur',
			// imageUrl: StoreEnrouleurInterieur,
			nextStep: TypeStorebanne,
			description:
				'- Fourniture d’un store enrouleur intérieur destiné à la gestion de la luminosité et du vis-à-vis. ' +
				'Installation adaptée à un usage intérieur, offrant confort visuel et intégration discrète dans l’habitat.',
		},

		{
			id: 'TSEN_EXT',
			label: 'Extérieur',
			value: 'Extérieur',
			// imageUrl: StoreEnrouleurExterieur,
			nextStep: TypeStorebanne,
			description:
				'- Fourniture d’un store enrouleur extérieur avec structure en aluminium, conçu pour une installation en façade. ' +
				'Assure une protection solaire efficace et contribue à la réduction des apports thermiques avant le vitrage.',
		}

	],
};

const StoreBanneProduit = {
	id: 'TF',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de fabrication',
	name: 'fabrication',
	className: 'col-12',
	nextStepData: false,
	nextStep: false,
	options: [
		{
			id: 11297,
			label: 'Toile store banne',
			value: 'Toile',
			imageUrl: ToileStoreBanne,
			nextStep: largeurStorebanne,
			description:
				'Fourniture d’une toile pour store banne, conçue pour le remplacement ou la rénovation de l’installation existante. ' +
				'Toile adaptée à un usage extérieur, assurant une protection solaire efficace et une bonne tenue dans le temps.',
		},
		{
			id: 11296,
			label: 'Store banne complet',
			value: 'Store banne',
			imageUrl: StoreBanne,
			nextStep: TypeStorebanne,
			description:
				'Fourniture d’un store banne avec structure en aluminium extrudé, équipé de bras Matest, conforme à la norme EN 13561.',
		},
		{
			id: 10047,
			label: 'Moteur',
			value: 'Moteur',
			imageUrl: MoteurStoreBanne,
			nextStep: moteur,
			description:
				'Fourniture d’un moteur pour store banne, compatible avec l’installation existante ou neuve. ' +
				'Motorisation assurant une manœuvre fluide et un confort d’utilisation optimal.',
		},
	],

};

const StoreData = {
	id: 'TF',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de Store',
	name: 'typeStore',
	className: 'col-12',
	nextStep: false,
	options: [
		{
			id: 11297,
			label: 'Store Banne',
			value: 'Store Banne',
			nextStep: StoreBanneProduit,
			imageUrl: StoreBanne,


		},
		{
			id: 11296,
			label: 'Store à projection',
			value: 'Store à projection',
			imageUrl: StoreProjection,
			nextStep: TypeStorebanne,
			description: "Fourniture d’un store à projection avec structure en aluminium extrudé, conforme à la norme EN 13561."
		},

		{
			id: 10047,
			label: 'Store enrouleur',
			value: 'Store enrouleur',
			nextStep: typeEnrouleur,
			imageUrl: StoreEnrouleur
		},
	],
};

export default StoreData;
